import { render, staticRenderFns } from "./lazy-product-training.vue?vue&type=template&id=bd664096"
import script from "./lazy-product-training.vue?vue&type=script&lang=js"
export * from "./lazy-product-training.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports